import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import { Card } from 'react-toolbox/lib/card'
import T from 'i18n-react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import Summary from './Summary'
import SystemInfo from './SystemInfo'
import AggregateTestReports from './AggregateTestReports'

class FinalReport extends Component {
    render(){
        return(
          <div>
              <Summary/>
              <SystemInfo />
              <AggregateTestReports />
          </div>
        )
    }
}

const withStyles = CSSModules(styles)
const enhance = compose(withStyles)
export default enhance(FinalReport)
